import contentConstraints from '@/assets/configurations/channels/contentConstraints'

const CONTENT_TO_LONG_ISSUE = 'Warning.mpe.payload.length'
const MEDIA_STATIC_UNDERFLOW = 'Warning.media.static.underflow'
const MEDIA_STATIC_OVERFLOW = 'Warning.media.static.overflow'
const MEDIA_DYNAMIC_UNDERFLOW = 'Warning.media.dynamic.underflow'
const MEDIA_DYNAMIC_OVERFLOW = 'Warning.media.dynamic.overflow'
const MEDIA_COMBINATION_INVALID = 'Warning.media.combination.one'

/**
 * Checks payloads content length
 * @param {Object} payload
 * @returns {Boolean} valid or not
 */
const checkContentLength = function (payload) {
  let valid = true
  if (!payload) return { valid, issue: CONTENT_TO_LONG_ISSUE }

  const { type } = payload
  const { content } = (payloadConstraintsFor(type) || {})

  // No content constraints - payload valid
  if (!content) return { valid, issue: CONTENT_TO_LONG_ISSUE }

  // Constraints - check constraint for given field
  for (const { field, constraints } of content) {
    // Max length
    if (constraints.maxLength) {
      const cField = payload[field] || ''
      valid = valid && cField.length <= constraints.maxLength
    }
  }

  return { valid, issue: CONTENT_TO_LONG_ISSUE }
}

/**
 * Returns constraints for requested post type only
 * @param {String} type
 * @returns {undefined|Object}
 */
const payloadConstraintsFor = (type) => {
  return contentConstraints[type]
}

 /**
 * Checks payloads media constraints
 * @param {String} type
 * @param {Number} staticCount
 * @param {Number} dynamicCount
 * @returns {Boolean} valid or not
 */
const checkMediaCount = function (type, staticCount = 0, dynamicCount = 0) {
  const { media } = (payloadConstraintsFor(type) || {})

  if (!media || (!staticCount && !dynamicCount)) return { valid: true, issue: null }

  // Check static media
  if (media.static) {
    if (media.static.min && staticCount < media.static.min) {
      return { valid: false, issue: MEDIA_STATIC_UNDERFLOW }
    }

    if (media.static.max && staticCount > media.static.max) {
      return { valid: false, issue: MEDIA_STATIC_OVERFLOW }
    }
  }

  if (media.dynamic) {
    if (!isNaN(parseInt(media.dynamic.min)) &&
      media.dynamic.min !== NaN &&
      // Actual constraint
      dynamicCount < media.dynamic.min) {

      return { valid: false, issue: MEDIA_DYNAMIC_UNDERFLOW }
    }

    if (!isNaN(parseInt(media.dynamic.max)) &&
      media.dynamic.max !== NaN &&
      // Actual constraint
      dynamicCount > media.dynamic.max) {

      return { valid: false, issue: MEDIA_DYNAMIC_OVERFLOW }
    }
  }

  if (media.allowedCombination) {
    switch (media.allowedCombination) {
      case 'one':
        if (!(!staticCount || !dynamicCount)) {
          return { valid: false, issue: MEDIA_COMBINATION_INVALID }
        }
        break
    }
  }

  return { valid: true, issue: null }
}

// Exports
export { checkContentLength, payloadConstraintsFor, checkMediaCount }



// WEBPACK FOOTER //
// ./src/assets/modules/constraints/payload.js